import React, { useEffect,useState } from "react";
import TopNav from "./Components/TopNav";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Home";
import $ from "jquery";

function App() {
 const [scrollToContact, setScrollToContact] = useState(() => () => {});
 const [scrollToCourse, setScrollToCourse] = useState(() => () => {});
  useEffect(() => {
    $(document).ready(() => {
      // Activate first navigation item
      $(".nav li:first").addClass("active");

      const showSection = (section, isAnimate) => {
        const direction = section.replace(/#/, "");
        const reqSection = $(".section").filter(`[data-section="${direction}"]`);

        if (!reqSection.length) {
          console.error(`Element with data-section="${direction}" not found`);
          return;
        }

        const reqSectionPos = reqSection.offset().top;

        if (isAnimate) {
          $("body, html").animate({ scrollTop: reqSectionPos }, 800);
        } else {
          $("body, html").scrollTop(reqSectionPos);
        }
      };

      const checkSection = () => {
        $(".section").each(function () {
          const $this = $(this);
          if (!$this.length) {
            console.warn("No sections found");
            return;
          }

          const topEdge = $this.offset().top - 80;
          const bottomEdge = topEdge + $this.height();
          const wScroll = $(window).scrollTop();

          if (topEdge < wScroll && bottomEdge > wScroll) {
            const currentId = $this.data("section");
            const reqLink = $("a").filter(`[href*="#${currentId}"]`);

            reqLink
              .closest("li")
              .addClass("active")
              .siblings()
              .removeClass("active");
          }
        });
      };

      $(".main-menu, .responsive-menu, .scroll-to-section").on(
        "click",
        "a",
        function (e) {
          e.preventDefault();
          showSection($(this).attr("href"), true);
        }
      );

      $(window).scroll(() => {
        checkSection();
      });
    });

    return () => {
      $(window).off("scroll");
      $(".main-menu, .responsive-menu, .scroll-to-section").off("click");
    };
  }, []);

  return (
    <main>
      <TopNav />
      <Header scrollToContact={scrollToContact} scrollToCourse={scrollToCourse}/>
      <Home setScrollToContact={setScrollToContact} setScrollToCourse={setScrollToCourse}/>
      <Footer />
    </main>
  );
}

export default App;
